/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/email_engagement_by_time_data" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { analyticsDashboardAppGroupIdEmailEngagementByTimeData } from "./constants";
import type { AnalyticsDashboardAppGroupIdEmailEngagementByTimeDataResult } from "./types";

export const getAnalyticsDashboardAppGroupIdEmailEngagementByTimeData = reactQueryFetcherAdapter(
  analyticsDashboardAppGroupIdEmailEngagementByTimeData,
  (
    signal: AbortSignal,
    app_group_id: string,
    start_date: number,
    end_date: number,
    toe_option: string
  ): Promise<AnalyticsDashboardAppGroupIdEmailEngagementByTimeDataResult> => {
    return fetch(
      `/analytics_dashboard/${app_group_id}/email_engagement_by_time_data`,
      "GET",
      { start_date, end_date, toe_option },
      { signal }
    );
  }
);
